import React from 'react';
import { Box, Typography } from '@mui/material';
import { SearchOff, FolderOpen, Inbox } from '@mui/icons-material';
import { motion } from 'framer-motion';
import colors from '../theme/colors';

const MotionBox = motion(Box);

interface EmptyStateProps {
  message?: string;
  icon?: 'search' | 'folder' | 'inbox';
  height?: string | number;
}

function EmptyState({ 
  message = 'No data found', 
  icon = 'inbox',
  height = 400 
}: EmptyStateProps) {
  const getIcon = () => {
    const iconProps = {
      sx: { 
        fontSize: 120, 
        color: colors.primary.light,
        opacity: 0.6,
      }
    };
    
    switch (icon) {
      case 'search':
        return <SearchOff {...iconProps} />;
      case 'folder':
        return <FolderOpen {...iconProps} />;
      default:
        return <Inbox {...iconProps} />;
    }
  };

  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height,
        py: 4,
      }}
    >
      <MotionBox
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        sx={{ mb: 3 }}
      >
        {getIcon()}
      </MotionBox>
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>
      <Typography
        variant="body2"
        color="text.disabled"
        sx={{
          mt: 1,
          textAlign: 'center',
        }}
      >
        Try adjusting your filters or create a new entry
      </Typography>
    </MotionBox>
  );
}

export default EmptyState;
